import { httpConstants } from "../lib/constants";
import axios from "axios";

async function createPayment(headers, requestData) {
    let url = `${process.env.REACT_APP_CARDPOINTE_API_URL}/api/payments${httpConstants.API_END_POINT.CREATE_PAYMENT}`;
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers,
    });
    return response || null;
}

const checkSurcharge = async (headers, requestData) => {
    let url = `${process.env.REACT_APP_CARDPOINTE_API_URL}/api/payments${httpConstants.API_END_POINT.CHECK_SURCHARGE}`;
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers,
    });
    return response || null;
};

const getACHToken = async (headers, requestData) => {
    let url = `${process.env.REACT_APP_CARDPOINTE_API_URL}/api/cardsecure${httpConstants.API_END_POINT.TOKENIZE}`;
    let response = await axios({
        method: "post",
        url: url,
        data: requestData,
        headers,
    });
    return response || null;
};

const service = { createPayment, checkSurcharge, getACHToken };
export default service;
